// Mesure de fréquentation : file d'évènements envoyée par lots (toutes les 4 s, à 20 évènements, sur un lien ou quand la page se ferme).
const API = process.env.REACT_APP_BACKEND_URL || '';

const isPointer = (n) => n?.nodeType === 1 && window.getComputedStyle(n).cursor === 'pointer';

/** Élément cliquable : bouton / lien, sinon la carte cliquable (curseur « main ») la plus large autour du clic. */
const clickable = (t) => {
  if (!t?.closest || t.closest('input,textarea,select,label,[contenteditable="true"]')) return null;
  const el = t.closest('a,button,[role="button"],[role="tab"],[data-track]');
  if (el) return el;
  if (!isPointer(t)) return null;
  let n = t;
  for (let i = 0; i < 8 && n.parentElement && n.parentElement !== document.body && isPointer(n.parentElement); i++) n = n.parentElement;
  return n;
};

/** Libellé lisible du bouton / lien / carte cliqué (jamais le contenu d'un champ de saisie). */
export const clickInfo = (e) => {
  const el = clickable(e.target);
  if (!el || el.closest('[data-no-track]')) return null;
  const heading = el.querySelector('h1,h2,h3,h4,h5');
  // Carte cliquable sans titre : seule la première ligne de texte sert de libellé
  const firstLine = (el.innerText || '').split('\n').map((s) => s.trim()).find(Boolean);
  const raw = el.getAttribute('data-track') || el.getAttribute('aria-label') || heading?.innerText || firstLine || el.getAttribute('title') || '';
  // Pastilles de compteur en fin de libellé (« Compte 15 ») retirées pour regrouper les clics
  const label = raw.replace(/\s+/g, ' ').trim().replace(/\s+\d+\+?$/, '').slice(0, 80);
  if (!label) return null;
  let target = null;
  const href = el.tagName === 'A' ? el.getAttribute('href') : null;
  if (href) {
    try {
      const u = new URL(href, window.location.href);
      const q = u.search.length < 60 && !/token|code|key/i.test(u.search) ? u.search : '';
      if (u.origin === window.location.origin) target = u.pathname + q;
      else target = u.protocol.startsWith('http') ? u.host : u.protocol.replace(':', '');
    } catch { target = null; }
  }
  return { label, target, isLink: !!href };
};

// Une même page n'est comptée qu'une fois si elle est signalée deux fois de suite en moins de 1,5 s
const lastPageview = {};
export const isNewPageview = (scope, page) => {
  const now = Date.now();
  const prev = lastPageview[scope];
  lastPageview[scope] = { page, at: now };
  return !(prev && prev.page === page && now - prev.at < 1500);
};

/** beacon=true : envoi texte sans en-tête (site public, pas de pré-requête) ; sinon fetch avec en-têtes (portail connecté). */
export const createTracker = ({ path, headers, beacon = false }) => {
  const queue = [];
  let timer = null;
  const flush = () => {
    clearTimeout(timer);
    timer = null;
    while (queue.length) {
      const body = JSON.stringify({ events: queue.splice(0, 50) });
      const url = `${API}${path}`;
      if (beacon && navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }))) continue;
      fetch(url, { method: 'POST', keepalive: true, headers: { 'Content-Type': beacon ? 'text/plain' : 'application/json', ...(headers ? headers() : {}) }, body }).catch(() => {});
    }
  };
  const onHide = () => { if (document.visibilityState === 'hidden') flush(); };
  document.addEventListener('visibilitychange', onHide);
  window.addEventListener('pagehide', flush);
  return {
    push(ev, now = false) {
      queue.push(ev);
      if (now || queue.length >= 20) flush();
      else if (!timer) timer = setTimeout(flush, 4000);
    },
    stop() {
      flush();
      document.removeEventListener('visibilitychange', onHide);
      window.removeEventListener('pagehide', flush);
    },
  };
};
